import { IconProps } from '@tamagui/helpers-icon';

export type HeaderIconProps = IconProps & {
  Icon: React.ComponentType<IconProps>;
};

export const HeaderIcon: React.FC<HeaderIconProps> = ({ Icon, ...props }) => {
  return <Icon size={'$2'} color={'$unistocks'} {...props} />;
};

HeaderIcon.displayName = 'HeaderIcon';
